import { Box, Divider, Grid, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { fMonthDayYear } from '../../../../../utils/formatTime';
import {
  getTransportContentSx,
  transportDetailsRowSx,
  transportDetailsSectionSx,
  transportFieldTitleSx,
  transportFieldValueSx,
} from '../transportTypographySx';
import RequestStatusBadge from './RequestStatusBadge';

AdditionalDetailsTab.propTypes = {
  request: PropTypes.object,
};

export default function AdditionalDetailsTab({ request }) {
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} sx={transportDetailsSectionSx}>
          <Box sx={transportDetailsRowSx}>
            <Typography sx={transportFieldTitleSx}>
              Created At:
              <Box component="span" sx={{ ...getTransportContentSx(true), ...transportFieldValueSx }}>
                {request?.dateAdded ? fMonthDayYear(new Date(request.dateAdded)) : ''}
              </Box>
            </Typography>
          </Box>
          <Divider />
          <Box sx={transportDetailsRowSx}>
            <Typography component="div" sx={transportFieldTitleSx}>
              Current Status:
              <Box component="span" sx={{ display: 'inline-flex', ml: '10px', verticalAlign: 'middle' }}>
                <RequestStatusBadge requestStatusId={request?.requestStatusId} />
              </Box>
            </Typography>
          </Box>
          <Divider />
          <Box sx={transportDetailsRowSx}>
            <Typography sx={transportFieldTitleSx}>
              Outsourced:
              <Box component="span" sx={{ ...getTransportContentSx(true), ...transportFieldValueSx }}>
                {request?.isOutsourced ? 'Yes' : 'No'}
              </Box>
            </Typography>
          </Box>
          <Divider />
          <Box sx={transportDetailsRowSx}>
            <Typography sx={transportFieldTitleSx}>
              Submitted By:
              <Box component="span" sx={{ ...getTransportContentSx(true), ...transportFieldValueSx }}>
                {request?.addedBy}
              </Box>
            </Typography>
          </Box>
          <Divider />
        </Grid>
      </Grid>
    </>
  );
}
